import React , {createContext, useState} from "react";

export const CmsCityPageAutoFilledCity = createContext({});

export const CmsCityProviders = ({children}) => {
    const [citesValue , setFromCityFromCmsPage] =useState(null);
    return (
        <CmsCityPageAutoFilledCity.Provider value={{citesValue , setFromCityFromCmsPage}}>
           {children}
        </CmsCityPageAutoFilledCity.Provider>
    )
}
